module.exports = __webpack_public_path__ + "static/media/clouds-cloud-svgrepo-com 1.de7771ee.webp";